import React, { useState } from 'react';
import './Contact.css';
import { useLanguage } from '../context/LanguageContext';

const Contact = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [status, setStatus] = useState({ loading: false, error: null, success: null });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, error: null, success: null });

    try {
      const response = await fetch('https://mhaskobaadmin.tipic.in/api/contact-usstore', {  // ← change this URL
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (!response.ok) {
        // Laravel validation error or other issue
        throw new Error(result.message || 'काहीतरी चूक झाली');
      }

      // Success
      setStatus({
        loading: false,
        success: result.message || 'संदेश यशस्वीपणे पाठवला गेला!',
        error: null
      });

      // Reset form
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });

    } catch (err) {
      setStatus({
        loading: false,
        success: null,
        error: err.message || 'सर्व्हरशी कनेक्ट होऊ शकले नाही'
      });
    }
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <span className="hero-pill">{t('nav.contact')}</span>
          <h1>{t('contact.heroTitle')}</h1>
          <div className="header-divider">
            <span className="dot"></span>
            <span className="line"></span>
            <span className="dot"></span>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="contact-content">
          <div className="contact-info-section">
            <div className="info-box">
              <h3>{t('contact.addressTitle')}</h3>
              <p>
                {t('contact.addressText').split('\n').map((line, i) => (
                  <React.Fragment key={i}>
                    {line}<br />
                  </React.Fragment>
                ))}
              </p>
            </div>

            <div className="info-box">
              <h3>{t('contact.phoneTitle')}</h3>
              <p>
                {t('contact.phoneText').split('\n').map((line, i) => (
                  <React.Fragment key={i}>
                    {line}<br />
                  </React.Fragment>
                ))}
              </p>
            </div>

            <div className="info-box">
              <h3>{t('contact.emailTitle')}</h3>
              <p>
                {t('contact.emailText').split('\n').map((line, i) => (
                  <React.Fragment key={i}>
                    {line}<br />
                  </React.Fragment>
                ))}
              </p>
            </div>

            <div className="info-box">
              <h3>{t('contact.timingTitle')}</h3>
              <p>
                {t('contact.timingText').split('\n').map((line, i) => (
                  <React.Fragment key={i}>
                    {line}<br />
                  </React.Fragment>
                ))}
                <br />
                {t('contact.officeTimingTitle')}:<br />
                {t('contact.officeTimingText').split('\n').map((line, i) => (
                  <React.Fragment key={i}>
                    {line}<br />
                  </React.Fragment>
                ))}
              </p>
            </div>
          </div>
        </div>

        <div className="contact-form-section">
          <h2>{t('contact.formTitle')}</h2>
          {status.success && <div className="alert alert-success">{t('contact.successMessage')}</div>}
          {status.error && <div className="alert alert-danger">{t('contact.errorMessage')}</div>}

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>{t('contact.fullName')}</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder={t('contact.fullNamePlaceholder')}
                />
              </div>

              <div className="form-group">
                <label>{t('contact.emailAddress')}</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder={t('contact.emailPlaceholder')}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>{t('contact.phoneNumber')}</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  placeholder={t('contact.phonePlaceholder')}
                />
              </div>

              <div className="form-group">
                <label>{t('contact.subject')}</label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder={t('contact.subjectPlaceholder')}
                />
              </div>
            </div>

            <div className="form-group">
              <label>{t('contact.message')}</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="6"
                placeholder={t('contact.messagePlaceholder')}
              ></textarea>
            </div>

            <button type="submit" className="submit-btn" disabled={status.loading}>
              {status.loading ? 'Sending...' : t('contact.sendMessage')}
            </button>
          </form>
        </div>

        <section className="map-section">
          <h2 className="section-title">{t('contact.findUs')}</h2>
          <div className="divider"></div>
          <div className="map-container">
            <iframe
              title={t('contact.mapTitle')}
              src="https://www.google.com/maps?q=Shri%20Kalbhairavnath%20Mhaskoba%20Maharaj%20Temple%2C%20Kodit%2C%20Purandar%2C%20Pune%2C%20Maharashtra%20412108&output=embed"
              width="100%"
              height="400"
              style={{ border: 0, borderRadius: '15px' }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Contact;









